// 后端地址解析：
// - 生产：HTTPS 经 nginx 同源反代 /api /socket.io → 用页面 origin（否则 https 页面连 http:3001 会被混合内容拦截）
// - 本地/局域网开发：vite dev server（:5173）直连后端 :3001
function resolveServerUrl(): string {
  if (typeof window === 'undefined') return 'http://localhost:3001';
  const loc = window.location;
  if (loc.protocol === 'https:') return loc.origin;
  if (loc.port === '5173' || loc.hostname === 'localhost' || loc.hostname === '127.0.0.1') {
    return `http://${loc.hostname}:3001`;
  }
  return loc.origin;
}

export const SERVER_URL = resolveServerUrl();

export interface UserStats {
  games: number;
  wins: number;
  losses: number;
  draws: number;
}

export interface UserInfo {
  id: string;
  username: string;
  nickname: string;
  createdAt: string;
  stats: UserStats;
  rank: number;
  rankLabel: string;
  avatar?: number; // 预设头像索引（0~11，缺省 0）
}

// 学员等级选项（与后端 rank.js 对齐）：15级 → 业余7段
export const RANK_OPTIONS: string[] = (() => {
  const list: string[] = [];
  for (let kyu = 15; kyu >= 1; kyu--) list.push(`${kyu}级`);
  for (let dan = 1; dan <= 7; dan++) list.push(`业余${dan}段`);
  return list;
})();

/** 强度值 strength（10=15级 … 24=1级 … 25=业余1段 … 31=业余7段）→ 显示名 */
export function rankLabel(strength: number): string {
  if (strength < 25) return `${25 - strength}级`;
  if (strength === 25) return '业余1段';
  return `业余${strength - 24}段`;
}

export const TOKEN_KEY = 'go-platform-token';

/** 登录页“记住账号”存储键（只存用户名，绝不存密码） */
export const REMEMBERED_USER_KEY = 'go-platform-remembered-user';

/** 设置预设头像：POST /api/auth/avatar，成功返回最新 user */
export async function changeAvatar(token: string, avatar: number): Promise<{ ok: boolean; user?: UserInfo; error?: string }> {
  const res = await fetch(SERVER_URL + '/api/auth/avatar', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, avatar }),
  });
  return res.json();
}

/** 设置昵称：POST /api/auth/nickname，成功返回最新 user */
export async function changeNickname(token: string, nickname: string): Promise<{ ok: boolean; user?: UserInfo; error?: string }> {
  const res = await fetch(SERVER_URL + '/api/auth/nickname', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, nickname }),
  });
  return res.json();
}

/** 修改密码：POST /api/auth/change-password，成功后当前 token 仍有效（不掉线） */
export async function changePassword(token: string, oldPassword: string, newPassword: string): Promise<{ ok: boolean; error?: string }> {
  const res = await fetch(SERVER_URL + '/api/auth/change-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, oldPassword, newPassword }),
  });
  return res.json();
}
